import React, { useState } from "react";
import styles from "./MaskedId.module.scss";
import clsx from "clsx";

function copyId(id) {
    return () => {
        navigator.clipboard.writeText(id).then(() => {
            console.debug(`Copied ${id} to clipboard`);
        });
    };
}

const MaskedText = ({ id, classNames }: { id: string; classNames?: string }) => {
    const [isRevealed, setIsRevealed] = useState(false);

    // Toggle reveal for mobile
    const handleClick = () => {
        setIsRevealed(!isRevealed);
    };

    return (
        <div
            className={clsx(classNames)}
            onClick={handleClick} // For mobile interaction
            onMouseEnter={() => setIsRevealed(true)} // For desktop hover
            onMouseLeave={() => setIsRevealed(false)} // For desktop hover
        >
            <img src="/images/copy.svg" alt="copy" className={styles.copyTopIcon} onClick={copyId(id)} />
            {id.slice(id.length - 9)}
        </div>
    );
};

export default MaskedText;
